import React, { useState, useEffect } from 'react';
import { 
    Table, TableBody, TableCell, TableContainer, TableRow, Paper, 
    TableHead, Button, TablePagination, TextField, Dialog, 
    DialogActions, DialogContent, DialogContentText, DialogTitle 
} from '@mui/material';
import AddPrioridadTarea from './AddPrioridadTarea';
import { useAccesos } from '../contexts/AccesosContext';

function GestionPrioridadTarea() {
const { tienePermiso } = useAccesos();

return (
<>
    <div className="x_title">
        </div>

        <div className="x_content">
            <br />

            <AddPrioridadTarea />

            <div className="ln_solid" />

            <h2>Prioridad de tarea existentes</h2>

            <div className="row">
                <div className="col-md-6 col-sm-4 offset-md-3">
                    <TextField
                        fullWidth
                        variant="outlined"
                        label="Buscar Prioridad de Tarea"
                        placeholder="Buscar..."
                        style={{ marginBottom: '20px' }}
                    />

                    <div className="table-responsive">
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Descripción</TableCell>
                                        <TableCell align="right">Acciones</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>Alta</TableCell>
                                        <TableCell align="right">
                                            <Button color="primary" disabled={!tienePermiso('Editar Prioridad Tarea')}>Editar</Button>
                                            <Button color="secondary" style={{ marginLeft: 10 }} disabled={!tienePermiso('Eliminar Prioridad Tarea')}>
                                                Eliminar
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Media</TableCell>
                                        <TableCell align="right">
                                            <Button color="primary" disabled={!tienePermiso('Editar Prioridad Tarea')}>Editar</Button>
                                            <Button color="secondary" style={{ marginLeft: 10 }} disabled={!tienePermiso('Eliminar Prioridad Tarea')}>
                                                Eliminar
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>Alta</TableCell>
                                        <TableCell align="right">
                                            <Button color="primary" disabled={!tienePermiso('Editar Prioridad Tarea')}>Editar</Button>
                                            <Button color="secondary" style={{ marginLeft: 10 }} disabled={!tienePermiso('Eliminar Prioridad Tarea')}>
                                                Eliminar
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>

                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={20} 
                                rowsPerPage={5}
                                page={0}
                                onPageChange={() => {}}
                                onRowsPerPageChange={() => {}}
                            />
                        </TableContainer>

                        <Dialog open={false}>
                            <DialogTitle>Eliminar Prioridad de Tarea</DialogTitle>
                            <DialogContent>
                                <DialogContentText>
                                    ¿Estás seguro de que quieres eliminar esta prioridad de tarea?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button color="primary">Cancelar</Button>
                                <Button color="primary" autoFocus>Eliminar</Button>
                            </DialogActions>
                        </Dialog>
                    </div>
                </div>
            </div>
        </div>
    </>

     
    );
}

export default GestionPrioridadTarea;